import React, { useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaRocket,FaUserTie,FaLayerGroup, FaCogs,  FaUsersCog,  FaChartLine,  FaWarehouse,  FaChalkboardTeacher,  FaNetworkWired,  FaProjectDiagram,  FaUserShield,  FaStore,  FaHeadset,} from "react-icons/fa";
import '../Assets/Css/startups.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import stratup from '../Assets/Image/stratup-img-1.jpeg'
import stratup1 from '../Assets/Image/startup-img-2.webp';
import { FaStar } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Helmet } from 'react-helmet';

const StartupsPage = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const testimonials = [
        "Trident’s services transformed our business operations — efficient, scalable, and tailored perfectly to our needs.",
        "Partnering with Trident empowered us to innovate faster and streamline workflows across all departments.",
        "The team at Trident combines deep expertise with a supportive approach, delivering results that truly matter.",
        "Since implementing Trident’s software, we’ve seen remarkable improvements in productivity and decision-making.",
        "Trident’s commitment to innovation and quality has made them a trusted partner in our digital transformation journey."
    ];


    const iconFeatures = [
      {
    icon: <FaCogs size={35} color="#fff" className="icon" />,
    title: "ERP System Integration",
  },
  {
    icon: <FaUsersCog size={35} color="#fff" className="icon" />,
    title: "CRM for Customer Engagement",
  },
  {
    icon: <FaNetworkWired size={35} color="#fff" className="icon" />,
    title: "Digital Supply Chain (DRP)",
  },
  {
    icon: <FaUserShield size={35} color="#fff" className="icon" />,
    title: "HRMS for Workforce Management",
  },
  {
    icon: <FaWarehouse size={35} color="#fff" className="icon" />,
    title: "Shopfloor Control Systems",
  },
  {
    icon: <FaProjectDiagram size={35} color="#fff" className="icon" />,
    title: "Production Planning Tools",
  },
  {
    icon: <FaStore size={35} color="#fff" className="icon" />,
    title: "Retail POS & Sales Solutions",
  },
  {
    icon: <FaHeadset size={35} color="#fff" className="icon" />,
    title: "Customer Support System",
  },
  {
    icon: <FaChalkboardTeacher size={35} color="#fff" className="icon" />,
    title: "Expert-Led Product Training",
  },
  {
    icon: <FaChartLine size={35} color="#fff" className="icon" />,
    title: "Analytics & ROI-Driven Adoption",
  },
    ];


    return (
        <>

        <Helmet>
  <title> Empowering Startups with Elite Tech Talent</title>
  <meta name="description" content="Trident helps startups accelerate from MVP to market leader with top-tier tech talent, agile execution, and product-focused strategy." />
  
  {/* Open Graph (for social sharing) */}
  <meta property="og:title" content="Trident Software Services | Built for Startups, Wired for Speed" />
  <meta property="og:description" content="Fuel your vision with Trident — your partner for tech talent, ERP, CRM, HRMS, and more." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://tridentsoftwareservice.com" />
  <meta property="og:image" content="https://tridentsoftwareservice.com/og-image.jpg" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Trident Software Services" />
  <meta name="twitter:description" content="Empowering startups with talent, systems, and strategy to lead in their markets." />
  <meta name="twitter:image" content="https://tridentsoftwareservice.com/twitter-image.jpg" />
</Helmet>

            <div className="enterprise-banner3-section d-flex align-items-center justify-content-center">
                <div className="enterprise-banner3-overlay text-center" data-aos="zoom-in">
                    <h2 className="banner1-title mb-3">Built for Startups. Wired for Speed.</h2>
                    <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">
                        Fuel your vision with elite tech talent, fast execution, and deep product insight — Trident empowers startups to go from MVP to market leader.
                    </p>

                </div>
            </div>

            <div className="py-5">
                <Container>
                    <Row className="align-items-center my-5">
                        <Col md={7} data-aos="fade-left">
                             <h3 className="fw-bold text-center section-title">More Than a Resume Match</h3>
                            <p className="text-muted">
                                At Trident Software services, we don't just fill roles — we forge partnerships. We align top-tier talent
                                with your long-term vision, ensuring cultural fit, growth mindset, and strategic alignment.
                            </p>
                            <p className="text-muted">
                                By deeply understanding your product roadmap and business goals, we connect you with professionals who
                                contribute not just skills, but foresight, initiative, and long-term impact.
                            </p>
                        </Col>
                        <Col md={5} data-aos="zoom-in" className="d-flex justify-content-center align-items-center">
                            <img src={stratup} alt="Tech Vision" className="aboutimg" />
                        </Col>
                    </Row>

                    <Row className="align-items-center mt-3 flex-md-row-reverse">
                        <Col md={7} data-aos="fade-right">
                             <h3 className="fw-bold text-center section-title">Quietly Brilliant Talent</h3>
                            <p className="text-muted">
                                The best developers aren't actively looking — they’re building, leading, and innovating behind the scenes.
                                We tap into exclusive, trusted talent circles through referrals, alumni networks, and private communities.
                            </p>
                            <p className="text-muted">
                                With a discreet and strategic approach, we uncover highly capable engineers, architects, and specialists
                                who might never appear on a job portal — but can redefine your product and tech outcomes.
                            </p>
                        </Col>
                        <Col md={5} data-aos="zoom-in" className="d-flex justify-content-center align-items-center">
                            <img src={stratup1} alt="Talent Network" className="aboutimg" />
                        </Col>
                    </Row>
                </Container>
            </div>


            <section className="pt-5 icon-padding-control">
                <div className="d-flex justify-content-center  icon-section experties-icons">
                    <Container>
                        <Row
                            className="text-center section-heading p-4"
                        >
                            <Col>
                                <h3 className="fw-bold text-white section-title">
                                    Startup-Focused Services
                                    <span className="title-decoration"></span>
                                </h3>
                                <p className="mx-auto" style={{ maxWidth: 600, color: '#ffcc99' }}>
                                </p>
                            </Col>
                        </Row>

                        <Row className="g-4 justify-content-center">
                            {iconFeatures.map((feature, index) => (
                                <Col
                                    key={index}
                                    md={3}
                                    className="text-center d-flex flex-column align-items-center startup-icon-item"
                                    data-aos="fade-up"
                                    data-aos-delay="100"
                                >
                                    {feature.icon}
                                    <div className="mt-3">
                                        <h5 className="fw-semibold">{feature.title}</h5>
                                        {/* <p>{feature.description}</p> */}
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </div>
            </section>

            <div className="startups-page">
                <div className="page-content">

                    {/* Why Choose Us Section */}
                    <section className="startup-why-trident py-5">
                        <Container>
                            <Row className="justify-content-center my-4">
                                <h3 className="fw-bold text-center section-title">
                                    Why Startups Choose Trident
                                    <span className="title-decoration mb-2"></span>
                                </h3>
                                {/* <p className="text-muted text-center" style={{ maxWidth: 700 }}>
                                                        Powering Business Transformation with Trusted Talent & Technology
                                                    </p> */}
                            </Row>
                            <Row className="text-center">
                                <Col md={4} className="mb-4">
                                    <div className="feature-card p-4 h-100 d-flex flex-column align-items-center">
                                        <FaRocket className="icon mb-3" />
                                        <h5 className="fw-semibold mt-3">Adaptive Hiring Models</h5>
                                        <p className="text-muted">Scale on demand based on your roadmap and sprint velocity.</p>
                                    </div>
                                </Col>
                                <Col md={4} className="mb-4">
                                    <div className="feature-card p-4 h-100 d-flex flex-column align-items-center">
                                        <FaUserTie className="icon mb-3" />
                                        <h5 className="fw-semibold mt-3">Pre-Vetted Talent Pool</h5>
                                        <p className="text-muted">From developers to DevOps to AI — we bring talent ready to deliver.</p>
                                    </div>
                                </Col>
                                <Col md={4} className="mb-4">
                                    <div className="feature-card p-4 h-100 d-flex flex-column align-items-center">
                                        <FaLayerGroup className="icon mb-3" />
                                        <h5 className="fw-semibold mt-3">Product-First Approach</h5>
                                        <p className="text-muted">We study your stack and lifecycle to find who fits your future.</p>
                                    </div>
                                </Col>
                            </Row>

                        </Container>
                    </section>
                </div>
            </div>

            <section className="ctasection text-white d-flex align-items-center" >
                <div className="container">
                    <div className="row align-items-center" data-aos="zoom-in" data-aos-delay="200">
                        <div className="col-12">
                            <div className="ctasection-content p-4 p-md-5 text-center">
                                <h2
                                    className="fw-bold mb-4"
                                    style={{
                                        fontFamily: "'Playfair Display', serif",
                                        fontSize: '2.5rem',
                                        letterSpacing: '1px',
                                    }}
                                >
                                    Empower Your Business Journey
                                </h2>
                                <p
                                    className="mb-4"
                                    style={{
                                        fontSize: '1.15rem',
                                        lineHeight: '1.6',
                                        color: '#f8f1e7',
                                        maxWidth: '750px',
                                        margin: '0 auto',
                                    }}
                                >
                                    From ERP and CRM to HRMS, POS, and beyond — our scalable services are built to help you streamline operations, boost performance, and grow confidently.
                                </p>
                                <Button variant="light" className="banner1-button mt-3 " href='/ourproducts'
                                    data-aos="zoom-in" data-aos-delay="300">
                                    Explore Our Products <IoArrowForwardCircleOutline size={30} style={{ animation: 'pulse 1.5s infinite', transformOrigin: 'center' }} />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>




            <section className="testimonial-carousel-section my-5">
                <div className="container py-3 ">
                    <Row className="align-items-center justify-content-center flex-md-row m-0">
                        <h3 className="fw-bold text-center section-title">
                            Empowering Innovation Through Experience
                            <span className="title-decoration mb-2"></span>
                        </h3>
                        <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                            Hear what our clients say about transforming their business with Trident Software services.
                        </p>
                        <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">

                            <Swiper
                                modules={[Autoplay, Pagination, Navigation]}
                                spaceBetween={30}
                                loop={true}
                                autoplay={{
                                    delay: 5000,
                                    disableOnInteraction: false,
                                }}
                                pagination={{ clickable: true }}
                                navigation={true}
                                className="testimonial-swiper"
                            >
                                {testimonials.map((text, idx) => (
                                    <SwiperSlide key={idx}>
                                        <div className="stars mb-1">
                                            {[...Array(5)].map((_, i) => (
                                                <FaStar key={i} color="#d23f57" />
                                            ))}
                                        </div>
                                        <p className="testimonial-quote">
                                            <span className="quote-mark">“</span>
                                            {text}
                                            <span className="quote-mark">”</span>
                                        </p>
                                        <p className="author-name">Anonymous</p>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </Col>
                    </Row>
                </div>
            </section>
        </>

    );
};

export default StartupsPage;
